(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hermes-product-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  var page=document.getElementById('hermes-product-page');
  if(!page)return;

  // Gallery
  var imgs=page.querySelectorAll('.hermes-main-img');
  var thumbs=page.querySelectorAll('.hermes-thumb');
  var counter=document.getElementById('hermes-counter');
  var currentIdx=0;
  function showImg(idx){
    imgs.forEach(function(el,i){el.classList.toggle('active',i===idx);});
    thumbs.forEach(function(el,i){el.classList.toggle('active',i===idx);});
    if(counter)counter.textContent=(idx+1)+'/'+imgs.length;
    currentIdx=idx;
  }
  window.hermesShowImg=showImg;
  thumbs.forEach(function(btn){btn.addEventListener('click',function(){showImg(parseInt(btn.dataset.index));});});
  var prev=page.querySelector('.hermes-prev');
  var next=page.querySelector('.hermes-next');
  if(prev)prev.addEventListener('click',function(){showImg((currentIdx-1+imgs.length)%imgs.length);});
  if(next)next.addEventListener('click',function(){showImg((currentIdx+1)%imgs.length);});

  // Quantity — always read from DOM so tier card clicks stay in sync
  var qtyVal=document.getElementById('hermes-qty-val');
  var qtyInput=document.getElementById('hermes-qty-input');
  var dec=document.getElementById('hermes-qty-dec');
  var inc=document.getElementById('hermes-qty-inc');
  function getQty(){return parseInt(qtyVal?qtyVal.textContent:1)||1;}
  function setQty(n){if(qtyVal)qtyVal.textContent=n;if(qtyInput)qtyInput.value=n;}
  window.hermesSetQty=setQty;
  if(dec&&inc&&qtyVal){
    dec.addEventListener('click',function(){var q=getQty();if(q>1)setQty(q-1);});
    inc.addEventListener('click',function(){setQty(getQty()+1);});
  }

  // Variant selection
  var allVariants = window.__hermesVariants__ || [];
  var selectedOpts = {};
  if (allVariants.length > 0) {
    allVariants[0].options.forEach(function(val, i) { selectedOpts[i] = val; });
  }
  function findVariant() {
    return allVariants.find(function(v) {
      return v.options.every(function(opt, i) { return opt === selectedOpts[i]; });
    }) || null;
  }
  function formatMoney(cents) {
    var fmt = window.__hermesMoneyFormat__ || '${{amount}}';
    var n = parseInt(cents, 10) || 0;
    var amt = (n / 100).toFixed(2);
    var noD = String(Math.floor(n / 100));
    var fmtAmt = amt.replace(/B(?=(d{3})+(?!d))/g, ',');
    var fmtNoD = noD.replace(/B(?=(d{3})+(?!d))/g, ',');
    return fmt
      .replace('{{amount}}', fmtAmt)
      .replace('{{amount_no_decimals}}', fmtNoD)
      .replace('{{amount_with_comma_separator}}', fmtAmt.replace(/,/g, ' ').replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', fmtNoD.replace(/,/g, '.'));
  }
  function updatePriceUI(variant) {
    var priceEl = page.querySelector('.hermes-price');
    var origEl  = page.querySelector('.hermes-original-price');
    var saveEl  = page.querySelector('.hermes-savings');
    if (!priceEl || variant.price == null) return;
    priceEl.textContent = formatMoney(variant.price);
    var cmp = variant.compare_at_price;
    if (cmp && cmp > variant.price) {
      var pct = Math.round((cmp - variant.price) * 100 / cmp);
      if (origEl) { origEl.textContent = formatMoney(cmp); origEl.style.display = ''; }
      if (saveEl) { saveEl.textContent = 'Save ' + pct + '%'; saveEl.style.display = ''; }
    } else {
      if (origEl) origEl.style.display = 'none';
      if (saveEl) saveEl.style.display = 'none';
    }
  }
  page.querySelectorAll('.hermes-swatch[data-value]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var idx = parseInt(btn.getAttribute('data-option-index'), 10) || 0;
      selectedOpts[idx] = btn.getAttribute('data-value');
      page.querySelectorAll('.hermes-swatch[data-option-index="' + idx + '"]').forEach(function(s) {
        s.classList.toggle('active', s === btn);
      });
      var variant = findVariant();
      if (!variant) return;
      var idInput = page.querySelector('input[name="id"]');
      if (idInput) idInput.value = variant.id;
      updatePriceUI(variant);
      if (variant.featured_image && variant.featured_image.position) {
        showImg(variant.featured_image.position - 1);
      }
    });
  });

  // Countdown — MIN:SEC:MS, updates every 100ms
  var minEl=document.getElementById('hermes-min');
  var secEl=document.getElementById('hermes-sec');
  var msEl=document.getElementById('hermes-ms');
  if(minEl&&secEl&&msEl){
    var bar=page.querySelector('.hermes-countdown-bar');
    var endDateStr=bar?bar.getAttribute('data-countdown-end'):'';
    // Counts down to the merchant's real sale end date only. No per-visitor
    // evergreen timer that restarts itself — that is fabricated urgency.
    var endTime=null;
    if(endDateStr&&endDateStr.length>3){
      var parsed=new Date(endDateStr).getTime();
      if(!isNaN(parsed))endTime=parsed;
    }
    var wrap=page.querySelector('.hermes-countdown-wrap');
    if(endTime===null||endTime<=Date.now()){
      // No date, or the sale already ended: remove the bar instead of faking time.
      if(wrap&&wrap.parentNode)wrap.parentNode.removeChild(wrap);
    }else{
      var pad=function(n){return String(Math.max(0,Math.floor(n))).padStart(2,'0');};
      var u1=document.getElementById('hermes-u1');
      var u2=document.getElementById('hermes-u2');
      var u3=document.getElementById('hermes-u3');
      var setUnits=function(a,b,c){
        if(u1&&u1.textContent!==a){u1.textContent=a;u2.textContent=b;u3.textContent=c;}
      };
      var timer=setInterval(tick,100);
      function tick(){
        var rem=Math.max(0,endTime-Date.now());
        if(rem===0){
          clearInterval(timer);
          if(wrap&&wrap.parentNode)wrap.parentNode.removeChild(wrap);
          return;
        }
        var ts=Math.floor(rem/1000);
        // A real end date can be days out, so the three slots roll up to
        // HRS:MIN:SEC once past an hour instead of showing 4-digit minutes.
        if(ts>=3600){
          setUnits('HRS','MIN','SEC');
          minEl.textContent=pad(Math.floor(ts/3600));
          secEl.textContent=pad(Math.floor(ts%3600/60));
          msEl.textContent=pad(ts%60);
        }else{
          setUnits('MIN','SEC','MS');
          minEl.textContent=pad(Math.floor(ts/60));
          secEl.textContent=pad(ts%60);
          msEl.textContent=pad(Math.floor((rem%1000)/10));
        }
      }
      tick();
    }
  }
})();

// Reviews: View More toggle
window.hermesToggleReviews=function(btn){
  var grid=document.getElementById('hermes-reviews-grid');
  if(!grid)return;
  var expanded=grid.classList.toggle('expanded');
  btn.textContent=expanded?'Show Less ▲':'View More Reviews ▼';
};

// Reviews: Mobile carousel — same cards, grid clips, track translates
(function(){
  var grid=document.getElementById('hermes-reviews-grid');
  var track=document.getElementById('hermes-carousel-track');
  var nav=document.getElementById('hermes-carousel-nav');
  var dotsWrap=document.getElementById('hermes-carousel-dots');
  if(!grid||!track||!nav||!dotsWrap)return;

  var isMobile=false;
  var idx=0;
  var cards=[];

  function slideWidth(){return grid.offsetWidth;}

  function buildDots(){
    dotsWrap.innerHTML='';
    for(var d=0;d<cards.length;d++){
      var dot=document.createElement('button');
      dot.className='hermes-carousel-dot'+(d===0?' active':'');
      dot.setAttribute('aria-label','Review '+(d+1));
      (function(i){dot.onclick=function(){goTo(i);};})(d);
      dotsWrap.appendChild(dot);
    }
  }

  function goTo(i){
    idx=Math.max(0,Math.min(i,cards.length-1));
    track.style.transition='transform 0.35s ease';
    track.style.transform='translateX(-'+(idx*slideWidth())+'px)';
    dotsWrap.querySelectorAll('.hermes-carousel-dot').forEach(function(d,n){
      d.classList.toggle('active',n===idx);
    });
  }

  function enableCarousel(){
    if(isMobile)return;
    isMobile=true;
    cards=Array.prototype.slice.call(grid.querySelectorAll('.hermes-review-card'));
    grid.classList.add('hermes-is-carousel');
    track.style.transform='translateX(0)';
    nav.style.display='flex';
    buildDots();
  }

  function disableCarousel(){
    if(!isMobile)return;
    isMobile=false;
    grid.classList.remove('hermes-is-carousel');
    track.style.transform='';
    track.style.transition='';
    nav.style.display='none';
    idx=0;
  }

  function check(){
    if(window.innerWidth<=768){enableCarousel();}
    else{disableCarousel();}
  }

  window.addEventListener('resize',function(){
    check();
    if(isMobile){
      track.style.transition='none';
      track.style.transform='translateX(-'+(idx*slideWidth())+'px)';
    }
  });

  window.hermesCarouselPrev=function(){goTo(idx-1);};
  window.hermesCarouselNext=function(){goTo(idx+1);};

  var startX=0;
  grid.addEventListener('touchstart',function(e){startX=e.touches[0].clientX;},{passive:true});
  grid.addEventListener('touchend',function(e){
    var dx=e.changedTouches[0].clientX-startX;
    if(Math.abs(dx)>40){dx<0?hermesCarouselNext():hermesCarouselPrev();}
  });

  check();
})();

// Bundle tier accordion — IPAG-style expand/collapse with variant selectors
(function(){
  var block=document.getElementById('hermes-bundle-block');
  if(!block)return;
  var tierCards=block.querySelectorAll('.hermes-tier-card');
  var tpl=document.getElementById('hermes-variant-row-tpl');
  var allVariants=window.__hermesVariants__||[];
  var formIdInput=document.querySelector('#hermes-product-form input[name="id"]');
  var formQtyInput=document.getElementById('hermes-qty-input');
  var baseSelVariantId=formIdInput?formIdInput.value:'';

  function findVariant(opts){
    return allVariants.find(function(v){
      return v.options.every(function(opt,i){return opts[i]===undefined||opt===opts[i];});
    })||allVariants[0];
  }

  function formatMoney(cents){
    var fmt=window.__hermesMoneyFormat__||'${{amount}}';
    var n=parseInt(cents,10)||0;
    var amt=(n/100).toFixed(2);
    var noD=String(Math.floor(n/100));
    var fmtAmt=amt.replace(/B(?=(d{3})+(?!d))/g,',');
    var fmtNoD=noD.replace(/B(?=(d{3})+(?!d))/g,',');
    return fmt.replace('{{amount}}',fmtAmt).replace('{{amount_no_decimals}}',fmtNoD)
      .replace('{{amount_with_comma_separator}}',fmtAmt.replace(/,/g,' ').replace('.',','))
      .replace('{{amount_no_decimals_with_comma_separator}}',fmtNoD.replace(/,/g,'.'));
  }

  function getSelectedOpts(panel){
    var opts={};
    var firstRow=panel.querySelector('.hermes-tier-item-row');
    if(!firstRow)return opts;
    firstRow.querySelectorAll('.hermes-tier-select').forEach(function(sel){
      opts[parseInt(sel.dataset.optionIndex)]=sel.value;
    });
    return opts;
  }

  function getCardCompareTotal(card,fallbackPrice){
    var rows=card.querySelectorAll('.hermes-tier-item-row');
    if(rows.length===0){
      var qty=parseInt(card.dataset.qty)||1;
      return fallbackPrice*qty;
    }
    var sum=0;
    rows.forEach(function(row){
      var v=findVariantForRow(row);
      sum+=(v?v.price:fallbackPrice);
    });
    return sum;
  }

  function updateAllTierPrices(fallbackPrice){
    tierCards.forEach(function(card){
      var pct=parseFloat(card.dataset.pct)||0;
      var qty=parseInt(card.dataset.qty)||1;
      var compare=getCardCompareTotal(card,fallbackPrice);
      var discounted=Math.round(compare*(100-pct)/100);
      var each=Math.round(discounted/qty);
      var totalEl=card.querySelector('.hermes-tier-total-price');
      var compareEl=card.querySelector('.hermes-tier-compare-price');
      var eachEl=card.querySelector('.hermes-tier-each-pill');
      if(totalEl)totalEl.textContent=formatMoney(discounted);
      if(compareEl)compareEl.textContent=formatMoney(compare);
      if(eachEl)eachEl.textContent='(Only '+formatMoney(each)+' each)';
    });
  }

  function populatePanel(card){
    var panel=card.querySelector('.hermes-tier-panel');
    var itemsContainer=panel.querySelector('.hermes-tier-items');
    if(!tpl||!itemsContainer||itemsContainer.children.length>0)return;
    var hasSelects=tpl.content.querySelectorAll('.hermes-tier-select').length>0;
    if(!hasSelects)return;
    var qty=parseInt(card.dataset.qty)||1;
    for(var i=0;i<qty;i++){
      var row=tpl.content.cloneNode(true);
      itemsContainer.appendChild(row);
    }
    var firstVariant=allVariants[0];
    if(firstVariant){
      itemsContainer.querySelectorAll('.hermes-tier-item-row').forEach(function(row){
        row.querySelectorAll('.hermes-tier-select').forEach(function(sel){
          var optIdx=parseInt(sel.dataset.optionIndex);
          if(firstVariant.options[optIdx])sel.value=firstVariant.options[optIdx];
        });
      });
    }
    itemsContainer.querySelectorAll('.hermes-tier-select').forEach(function(sel){
      sel.addEventListener('change',function(){onVariantChange(card,sel.closest('.hermes-tier-item-row'));});
      sel.addEventListener('click',function(e){e.stopPropagation();});
    });
  }

  function findVariantForRow(row){
    var opts={};
    row.querySelectorAll('.hermes-tier-select').forEach(function(sel){
      opts[parseInt(sel.dataset.optionIndex)]=sel.value;
    });
    return findVariant(opts);
  }

  function onVariantChange(card,changedRow){
    var panel=card.querySelector('.hermes-tier-panel');
    var variant=changedRow?findVariantForRow(changedRow):null;
    if(changedRow&&variant){
      var thumb=changedRow.querySelector('.hermes-tier-item-thumb');
      if(thumb&&variant.featured_image&&variant.featured_image.src){
        thumb.src=variant.featured_image.src.replace(/(.[^.]+)$/,'_80x80$1');
      }
    }
    var firstRow=panel.querySelector('.hermes-tier-item-row');
    var firstVariant=firstRow?findVariantForRow(firstRow):null;
    if(firstVariant){
      if(formIdInput)formIdInput.value=firstVariant.id;
      updateAllTierPrices(firstVariant.price);
      if(firstVariant.featured_image&&firstVariant.featured_image.position&&window.hermesShowImg){
        window.hermesShowImg(firstVariant.featured_image.position-1);
      }
    }
  }

  function selectTier(card){
    tierCards.forEach(function(tc){tc.classList.remove('selected');});
    card.classList.add('selected');
    var qty=parseInt(card.dataset.qty)||1;
    if(formQtyInput)formQtyInput.value=qty;
    populatePanel(card);
    var panel=card.querySelector('.hermes-tier-panel');
    var opts=getSelectedOpts(panel);
    var variant=findVariant(opts);
    if(variant&&formIdInput)formIdInput.value=variant.id;
  }

  tierCards.forEach(function(card){
    card.addEventListener('click',function(e){
      if(e.target.closest('.hermes-tier-select')||e.target.closest('.hermes-tier-qty-btn'))return;
      if(card.classList.contains('selected')){
        card.classList.remove('selected');
        if(formQtyInput)formQtyInput.value=1;
        if(formIdInput)formIdInput.value=baseSelVariantId;
        return;
      }
      selectTier(card);
    });
    var decBtn=card.querySelector('.hermes-tier-dec');
    var incBtn=card.querySelector('.hermes-tier-inc');
    var qtySpan=card.querySelector('.hermes-tier-qty-val');
    var baseQty=parseInt(card.dataset.qty)||1;
    if(decBtn)decBtn.addEventListener('click',function(e){
      e.stopPropagation();
      var cur=parseInt(qtySpan.textContent)||baseQty;
      if(cur>baseQty){cur-=baseQty;qtySpan.textContent=cur;if(formQtyInput)formQtyInput.value=cur;}
    });
    if(incBtn)incBtn.addEventListener('click',function(e){
      e.stopPropagation();
      var cur=parseInt(qtySpan.textContent)||baseQty;
      cur+=baseQty;qtySpan.textContent=cur;if(formQtyInput)formQtyInput.value=cur;
    });
  });

  var form=document.getElementById('hermes-product-form');
  if(form)form.addEventListener('submit',function(e){
    var selectedCard=block.querySelector('.hermes-tier-card.selected');
    if(!selectedCard)return;
    var rows=selectedCard.querySelectorAll('.hermes-tier-item-row');
    if(rows.length<=1)return;
    e.preventDefault();
    var items=[];
    var seen={};
    rows.forEach(function(row){
      var v=findVariantForRow(row);
      if(!v)return;
      var key=String(v.id);
      if(seen[key]){seen[key].quantity++;}
      else{seen[key]={id:v.id,quantity:1};items.push(seen[key]);}
    });
    if(!items.length)return;
    var btn=form.querySelector('.hermes-add-to-cart');
    if(btn){btn.disabled=true;btn.textContent='Adding...';}
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:items})
    }).then(function(r){return r.json();}).then(function(){
      window.location.href='/cart';
    }).catch(function(){
      if(btn){btn.disabled=false;btn.textContent='ADD TO CART';}
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
